import { z } from 'zod';
import { CustomDetailDataTypeEnum } from '@dealstack/shared/lib/generated';
import { InvestorCustomField } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/CustomFieldsCard/customFields.utils.ts';

export const CUSTOM_FIELD_MAX_LENGTH = 1000;

export const CustomFieldsShape = (customFields: InvestorCustomField[], invalidNumber: string) =>
	z
		.object({
			values: z.record(z.string().trim().max(CUSTOM_FIELD_MAX_LENGTH)),
		})
		.superRefine(({ values }, ctx) => {
			for (const field of customFields) {
				const value = values[field.id];

				if (
					value &&
					value !== (field.value ?? '') &&
					field.dataType === CustomDetailDataTypeEnum.NUMBER &&
					!Number.isFinite(Number(value))
				) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						path: ['values', field.id],
						message: invalidNumber,
					});
				}
			}
		});

export type CustomFieldsFormValues = z.infer<ReturnType<typeof CustomFieldsShape>>;
